// React
import ReactDOM from 'react-dom';

var React = require('react');
var createReactClass = require('create-react-class');

// JSON Data retrieval
// expects parameter of endpoint to fetch
import { populate } from './../utilities/functions/populate.js';
import { getAllUrlParams } from './../utilities/functions/getAllURLParams.js';

// Pager
import Pagination from './../utilities/functions/Pagination';

var Loader = require('react-loader');

var GlossaryContainer =  createReactClass({

    // initial state of component
    getInitialState: function() {

        return({
            endpoint : '/rest/legal_guidance_az?_format=json',
            data : [],            
            loaded : false,
            results_summary : '',
            count : '',
            page : 0,
        })
    },

    // this is run once when the component mounts dom node
    componentDidMount: function(){
        var component = this;

        let letter = getAllUrlParams().letter ? getAllUrlParams().letter.toUpperCase() : 'A';
        
        //scroll
        if ( getAllUrlParams().letter ) {
            document.getElementById("alphabet").scrollIntoView();
        }
        
        var active_letter = document.querySelectorAll('[data-letter="' + letter + '"]');

        active_letter[0].classList.add('active');

        populate( component.state.endpoint + '&title=' + letter )
            .then(function( response ){

                // update components data state
                component.setState({
                    data : response.data.results,
                    loaded : true,
                    active_letter : letter,
                    page : 0,
                    count : response.data.count,
                });
            });

    },

    render: function() {

        var component = this;

        return (
            <div className="glossary">
                <Loader loaded = { component.state.loaded } />
                { component.state.active_letter != '' ? <div className="heading_letter"> {  component.state.active_letter} </div> 
                    : <div className="results-summary"> { component.state.results_summary  } </div> }
                <Posts
                    data = { component.state.data }
                />
                <div className="align-center">
                    <Pagination
                        activePage = { (parseInt(component.state.page) + 1) }
                        itemsCountPerPage = { 50 }
                        totalItemsCount = { parseInt(component.state.count) }
                        pageRangeDisplayed = { 9 }
                        onChange= { this.processPager }
                        hideDisabled = { true }
                        linkClass = { 'pagination--link' }
                        prevPageText = { 'Prev' }
                        nextPageText = { 'Next' }
                        lastPageText = { '' }
                        firstPageText = { '' }
                    />
                </div>
            </div>
        )
    },

    processPager: function(pageNumber){

        var component = this;

        component.setState({
            loaded: false
        });

        let page = pageNumber != '' ? '&page=' + (pageNumber - 1) : '&page=1';
        component.setState({ page: pageNumber - 1 });

        let keyword = document.getElementById('keyword').value;
	let letter = keyword == '' ? '&title=' + component.state.active_letter : '';
        populate( component.state.endpoint + '&combine=' + keyword + page + letter)
            .then(function( response ){

                // update components data state
                glossary_container.setState({
                    data : response.data.results,
                    loaded : true,
                    active_letter : keyword == '' ? component.state.active_letter : '',
                    count : response.data.count,
                    results_summary :  keyword == '' ? '' : 'Search results for term: ' + keyword
                });
            });    
    }


});


var alphabetButtons = document.querySelectorAll('.letter');
if ( alphabetButtons ) {
    for ( var x = 0; x < alphabetButtons.length; x++ ) {
        alphabetButtons[x].addEventListener('click', function(e) {

            var alphabetButtons = document.querySelectorAll('.letter');
            for ( var i = 0; i < alphabetButtons.length; i++ ) {
                alphabetButtons[i].classList.remove('active');
            }

            this.classList.add('active');

            let letter = this.dataset.letter;

            let keyword = document.getElementById('keyword').value ? '&combine=' + document.getElementById('keyword').value: '';

            glossary_container.setState({ loaded: false });

            populate( glossary_container.state.endpoint + '&title=' + letter + keyword)
            .then(function( response ){

                // update components data state
                glossary_container.setState({
                    data : response.data.results,
                    loaded : true,
                    active_letter : letter,
                    count : response.data.count,
                });
            });

        });
    }

}

var keywordSearch = document.getElementById('keyword-search');
if ( keywordSearch ) {
    keywordSearch.addEventListener('click', function(e) {
        var keyword = document.getElementById('keyword').value;
        if ( keyword != '' ) {

            glossary_container.setState({ loaded: false });

            populate( glossary_container.state.endpoint + '&combine=' + keyword )
            .then(function( response ){

                // update components data state
                glossary_container.setState({
                    data : response.data.results,
                    loaded : true,
                    active_letter : '',
                    count : response.data.count,
                    page : 0,
                    results_summary : 'Search results for term: ' + keyword
                });
            });

        }
    });
}


// Posts component
var Posts = createReactClass({

    render() {

        // if we have a data array of posts
        if ( this.props.data.length > 0 ) {

            const posts = this.props.data.map( ( dataObject ) => {

                return (

                    <Post
                        key={ dataObject.nid.toString() }
                        id = { dataObject.nid }
                        link = { dataObject.external_url ? dataObject.external_url : dataObject.path }
                        external_url = { dataObject.external_url }
                        title = { dataObject.title }
                        body = { dataObject.body }
                        file = { dataObject.file }
                        related_legal_guidance = { dataObject.related_legal_guidance }
                        related_publications = { dataObject.related_publications }
                    />

                )

            });

            return (
                <div>{ posts }</div>
            )

        }
        // otherwise
        else {
            return <div>No Results found</div>;
        }

    },

});


var Post = createReactClass({

    render() {

        let glossary_html = '';
        let related = '';        
        let related_when_body = '';
        let file = '';

        if ( this.props.body == '' ) {

            if ( this.props.file ) {
                glossary_html = <span><div className="link-icon"><i className="fa fa-file-pdf-o"></i></div>
                                <span  dangerouslySetInnerHTML={ this.createMarkup( this.props.title )} />
                                </span>;

                file = <span dangerouslySetInnerHTML={ this.createMarkup( ' see: ' + this.props.file  )} />;          
            }
            else if ( this.props.external_url ) {
                glossary_html = <span><div className="link-icon"><i className="icon icon-link"></i></div>
                                <a href={ this.props.external_url } className="article--link">
                                <span  dangerouslySetInnerHTML={ this.createMarkup( this.props.title )} /></a></span>;    
                
            }
            else {
                glossary_html = <span><div className="link-icon"><i className="icon icon-link"></i></div>
                                <span  dangerouslySetInnerHTML={ this.createMarkup( this.props.title )} /></span>;
            }

            
            if ( this.props.related_legal_guidance != '' || this.props.related_publications != '' ) {
                related = <span dangerouslySetInnerHTML={ this.createMarkup( ' see: ' + this.props.related_legal_guidance + ' ' + this.props.related_publications )} />;
            }

        }
        else {

            if ( this.props.related_legal_guidance != '' || this.props.related_publications != '' ) {
                related_when_body = <span dangerouslySetInnerHTML={ this.createMarkup( ' see: ' + this.props.related_legal_guidance + ' ' + this.props.related_publications )} />;
            }  
            glossary_html = <div><div className="link-icon"><i className="icon icon-link"></i></div>
                            <div className="after-link-icon"><span><a href={ this.props.link } className="article--link">
                                <span dangerouslySetInnerHTML={ this.createMarkup( this.props.title )} />
                            </a></span>
                            { related_when_body  }
                            </div>
                            </div>;
                          
        }


        return (
            
            <div className="clearfix glossary-link"> 
                { glossary_html } { file } { related  }
            </div>
        );

    },


    createMarkup : function( html ) {
        return { __html: html };
    },


});


// checks to see if dom nodes exists
// and mounts twitter container component if so
if ( document.getElementById('glossary') ) {

    var glossary_container = ReactDOM.render(
        <GlossaryContainer/>,
        document.getElementById('glossary')
    );

}